var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:_setup.tabItemThemes({ active: _setup.rootValue === _setup.props.value }),attrs:{"data-component":"CsTabItem"},on:{"click":_setup.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }